export default __webpack_public_path__ + "static/media/first_icon.c2407c38.svg";